/****************FETCHING V SERIES ********************/
  var compareV = document.querySelectorAll(".compare-options-VSeries option");
  var uniqueValuesV = new Set();
  for (var i = 0; i < compareV.length-1; i++) {
      var textContentV = compareV[i].textContent;
      if (!uniqueValuesV.has(textContentV)) {
          compareV[i].setAttribute('value', textContentV);
          uniqueValuesV.add(textContentV);
      }
  }
  var blocksV = document.querySelectorAll(".products-compare-wrapper .product-compare-list .compare-options-VSeries");
  blocksV.forEach(function (block, blockIndexV) {
      uniqueValuesV.forEach(function (value) {
          var option = document.createElement('option');
          option.value = value;
          option.text = value;
          option.classList.add('newlyaddedVSeries');
          block.add(option);
      });
      if (blockIndexV < uniqueValuesV.size) {
          block.selectedIndex = blockIndexV;
          var selectedOptionV = block.options[blockIndexV];
          selectedOptionV.classList.add('activeOption');
      } else {
          block.options[blockIndexV].classList.remove('activeOption');
      }
  });
  
  var ActiveOptions = document.querySelector(".activeOption");
  if(ActiveOptions){
  var newAddedOptions = document.querySelectorAll(".newlyaddedVSeries");
  newAddedOptions.forEach(function(optionsNew) {
    var data = optionsNew.textContent;
    if (optionsNew.classList.contains("activeOption")) {
      optionsNew.style.display = "block";
    } else {
      optionsNew.style.display = "none";
    }
  });
  ActiveOptions.style.display = "block";
  }
  
  
  // Function to add click event listener to selectionOuter
  function addClickEventListenerVSeries(selectionOuter) {
    selectionOuter.addEventListener("click", function () {
        var selection = selectionOuter.querySelector(".activeOption");
        var nearestAncestor = selection.closest(".v-series.product-compare-block");    
      var matchedDiv = document.querySelector(".matched");
        var previousDiv = document.querySelector(".previousdiv");
        if (previousDiv) {
            previousDiv.classList.remove("previousdiv");
        }
  
        if (nearestAncestor) {
            nearestAncestor.classList.add("previousdiv");
        }
    });
  }
  
  // Function to add change event listener to selectElement
  function addChangeEventListenerVSeries(selectElement) {
    selectElement.addEventListener("change", function () {
        var selectedOptionTSeries = selectElement.options[selectElement.selectedIndex];
        for (var i = 0; i < selectElement.options.length; i++) {
            selectElement.options[i].classList.remove("selected");
        }
        selectedOptionTSeries.classList.add("selected");
  
        setTimeout(function () {
            var parentDiv = document.querySelector("#v-series .selected");
            var parentDivContent = parentDiv.textContent;
            var completeBlock = document.querySelectorAll(".product-compare-block");
            var matchedElement;
            completeBlock.forEach(function (element) {
                var completeBlockAttribute = element.getAttribute('value');
                if (parentDivContent === completeBlockAttribute) {
                    matchedElement = element;
                    element.classList.add('matched');
                } else {
                    element.classList.remove('matched');
                }
            });
  
            setTimeout(function () {
                 var matchedDiv = document.querySelector(".matched");
              if (matchedDiv) {
                  var previousDiv = document.querySelector(".previousdiv");
                  if (previousDiv && matchedDiv) {
                      var parent = previousDiv.parentNode;
                      var indexPreviousDiv = Array.from(parent.children).indexOf(previousDiv);
                      var indexMatchedDiv = Array.from(parent.children).indexOf(matchedDiv);
              
                      if (indexPreviousDiv !== -1 && indexMatchedDiv !== -1) {
                          // Remove swiper-slide-active from all elements in the parent
                          Array.from(parent.children).forEach(function (child) {
                              child.classList.remove("swiper-slide-active");
                          });
              
                          // Swap the positions only if they are different
                          if (indexPreviousDiv !== indexMatchedDiv) {
                              parent.replaceChild(matchedDiv, previousDiv);
                              parent.insertBefore(previousDiv, parent.children[indexMatchedDiv]);
                          }
                      }
                                                
                      // Reattach event listener to the moved element
                      var newSelectionOuter = document.querySelector(".product-compare-block.matched .compare-options-VSeries");
                      addClickEventListenerVSeries(newSelectionOuter);
                      var previousSelectedElement = document.querySelector(".product-compare-block.matched .compare-options-VSeries .selected");
                      if (previousSelectedElement) {
                          previousSelectedElement.classList.remove("selected");
                      }       
                      // Add swiper-slide-active to the first t-series element in the parent after div swapping
                      Array.from(parent.children).forEach(function (child) {
                          child.classList.remove("swiper-slide-active");
                      });
              
                      var firstTseriesElement = parent.querySelector(".v-series");
                      if (firstTseriesElement) {
                          firstTseriesElement.classList.add("swiper-slide-active");
                      }
                  }
              var previousDivValueV = document.querySelector(".previousdiv").getAttribute("value");
                  var selectedOptionv = document.querySelector(".previousdiv .compare-options-VSeries option.selected");
                  var options = document.querySelectorAll(".previousdiv .compare-options-VSeries option");
                    options.forEach(option => {
                      if (option.textContent.trim() === previousDivValueV.trim()) {                       
                        selectedOptionv.classList.remove("selected");
                          option.removeAttribute("selected");
                        option.setAttribute("selected", "selected");
                          option.click();
                      }
                    });
              }
            }, 500); 
          }, 300);
    });
  }
  
  
  var selectionOuters = document.querySelectorAll(".compare-options-VSeries");
  selectionOuters.forEach(addClickEventListenerVSeries);
  
  var selectElementsT = document.querySelectorAll(".compare-options-VSeries");
  selectElementsT.forEach(addChangeEventListenerVSeries);
  
    function setSelectedOptionV() {
      setTimeout(function() {
        var productCompareBlocks = document.querySelectorAll('.product-compare-block');
        productCompareBlocks.forEach(function(block) {
          var blockValue = block.getAttribute('value');
          var selectElementopt = block.querySelector('.compare-options-VSeries');
          if(selectElementopt){
          var options = selectElementopt.querySelectorAll('option');
          options.forEach(function(option) {
            if (option.value === blockValue) {
              option.selected = true;
            }
          });
        }
        });
      }, 800);
    }


/****************FETCHING T SERIES ********************/
var compareT = document.querySelectorAll(".compare-options-vaccum option");
var uniqueValuesT = new Set();
for (var i = 0; i < compareT.length-1; i++) {
    var textContentT = compareT[i].textContent;
    if (!uniqueValuesT.has(textContentT)) {
        compareT[i].setAttribute('value', textContentT);
        uniqueValuesT.add(textContentT);
    }
}

var blocksT = document.querySelectorAll(".products-compare-wrapper .product-compare-list .compare-options-vaccum");
blocksT.forEach(function (block, blockIndexT) {
    uniqueValuesT.forEach(function (value) {
        var option = document.createElement('option');
        option.value = value;
        option.text = value;
        option.classList.add('newlyaddedTSeries');
        block.add(option);
    });
    if (blockIndexT < uniqueValuesT.size) {
        block.selectedIndex = blockIndexT;
        var selectedOptionT = block.options[blockIndexT];
        selectedOptionT.classList.add('activeOption');
    } else {
        block.options[blockIndexT].classList.remove('activeOption');
    }
});

var ActiveOptions = document.querySelector(".activeOption");
var newAddedOptions = document.querySelectorAll(".newlyaddedTSeries");
newAddedOptions.forEach(function(optionsNew) {
  var data = optionsNew.textContent;
  if (optionsNew.classList.contains("activeOption")) {
    optionsNew.style.display = "block";
  } else {
    optionsNew.style.display = "none";
  }
});
ActiveOptions.style.display = "block";

// Function to add click event listener to selectionOuter
function addClickEventListener(selectionOuter) {
    selectionOuter.addEventListener("click", function () {
        var selection = selectionOuter.querySelector(".activeOption");
        var nearestAncestor = selection.closest(".t-series.product-compare-block");    
      var matchedDiv = document.querySelector(".matched");
        var previousDiv = document.querySelector(".previousdiv");
        if (previousDiv) {
            previousDiv.classList.remove("previousdiv");
        }

        if (nearestAncestor) {
            nearestAncestor.classList.add("previousdiv");
        }
    });
}
// Function to add change event listener to selectElement
function addChangeEventListener(selectElement) {
    selectElement.addEventListener("change", function () {
        var selectedOptionTSeries = selectElement.options[selectElement.selectedIndex];
        for (var i = 0; i < selectElement.options.length; i++) {
            selectElement.options[i].classList.remove("selected");
        }
        selectedOptionTSeries.classList.add("selected");

        setTimeout(function () {
            var parentDiv = document.querySelector("#t-series .selected");
            var parentDivContent = parentDiv.textContent;
            var completeBlock = document.querySelectorAll(".product-compare-block");
            var matchedElement;
            completeBlock.forEach(function (element) {
                var completeBlockAttribute = element.getAttribute('value');
                if (parentDivContent === completeBlockAttribute) {
                    matchedElement = element;
                    element.classList.add('matched');
                } else {
                    element.classList.remove('matched');
                }
            });

            setTimeout(function () {
              var matchedDiv = document.querySelector(".matched");
               if (matchedDiv) {
                  var previousDiv = document.querySelector(".previousdiv");
                  if (previousDiv && matchedDiv) {
                      var parent = previousDiv.parentNode;
                      var indexPreviousDiv = Array.from(parent.children).indexOf(previousDiv);
                      var indexMatchedDiv = Array.from(parent.children).indexOf(matchedDiv);
              
                      if (indexPreviousDiv !== -1 && indexMatchedDiv !== -1) {
                          // Remove swiper-slide-active from all elements in the parent
                          Array.from(parent.children).forEach(function (child) {
                              child.classList.remove("swiper-slide-active");
                          });
              
                          // Swap the positions only if they are different
                          if (indexPreviousDiv !== indexMatchedDiv) {
                              parent.replaceChild(matchedDiv, previousDiv);
                              parent.insertBefore(previousDiv, parent.children[indexMatchedDiv]);
                          }
                      }
      
                      // Reattach event listener to the moved element
                      var newSelectionOuter = document.querySelector(".product-compare-block.matched .compare-options-TSeries");
                      addClickEventListener(newSelectionOuter);
                      var previousSelectedElement = document.querySelector(".product-compare-block.matched .compare-options-TSeries .selected");
                      if (previousSelectedElement) {
                          previousSelectedElement.classList.remove("selected");
                      }       
                      // Add swiper-slide-active to the first t-series element in the parent after div swapping
                      Array.from(parent.children).forEach(function (child) {
                          child.classList.remove("swiper-slide-active");
                      });
              
                      var firstTseriesElement = parent.querySelector(".t-series");
                      if (firstTseriesElement) {
                          firstTseriesElement.classList.add("swiper-slide-active");
                      }
                  }

                   var previousDivValue = document.querySelector(".previousdiv").getAttribute("value");
                  var selectedOption = document.querySelector(".previousdiv .compare-options-TSeries option.selected");
                  var options = document.querySelectorAll(".previousdiv .compare-options-TSeries option");
                    options.forEach(option => {
                      if (option.textContent.trim() === previousDivValue.trim()) {                       
                        selectedOption.classList.remove("selected"); 
                        option.removeAttribute("selected");
                        option.setAttribute("selected", "selected");
                          option.click();
                      }
                    });
                }
            }, 500); 
          }, 300);
    });
}


var selectionOuters = document.querySelectorAll(".compare-options-TSeries");
selectionOuters.forEach(addClickEventListener);

var selectElementsT = document.querySelectorAll(".compare-options-TSeries");
selectElementsT.forEach(addChangeEventListener);


  function setSelectedOptionT() {
    setTimeout(function() {
      var productCompareBlocks = document.querySelectorAll('.product-compare-block');
      productCompareBlocks.forEach(function(block) {
        var blockValue = block.getAttribute('value');
        var selectElementopt = block.querySelector('.compare-options-TSeries');
        if(selectElementopt){
        var options = selectElementopt.querySelectorAll('option');
        options.forEach(function(option) {
          if (option.value === blockValue) {
            option.selected = true;
          }
        });
      }
      });
    }, 800);
  }



/****************FETCHING H SERIES********************/
var compareH = document.querySelectorAll(".compare-options-HSeries option");
var uniqueValuesH = new Set();
for (var i = 0; i < compareH.length-1; i++) {
    var textContentH = compareH[i].textContent;
    if (!uniqueValuesH.has(textContentH)) {
        compareH[i].setAttribute('value', textContentH);
        uniqueValuesH.add(textContentH);
    }
}
var blocksH = document.querySelectorAll(".products-compare-wrapper .product-compare-list .compare-options-HSeries");
blocksH.forEach(function(block) {
    uniqueValuesH.forEach(function(value) {
        var option = document.createElement('option');
        option.value = value;
        option.text = value;
        option.classList.add('newlyaddedHSeries');
        block.add(option);
    });
    var blockIndexH = Array.from(blocksH).indexOf(block);
    if (blockIndexH < uniqueValuesH.size) {
        block.selectedIndex = blockIndexH; 
        var selectedOption = block.options[blockIndexH];
      selectedOption.classList.add('activeOption');
    }else{
        block.options[blockIndexH].classList.remove('activeOption');
    }
});

var ActiveOptions = document.querySelector(".activeOption");
var newAddedOptions = document.querySelectorAll(".newlyaddedHSeries");
newAddedOptions.forEach(function(optionsNew) {
  var data = optionsNew.textContent;
  if (optionsNew.classList.contains("activeOption")) {
    optionsNew.style.display = "block";
  } else {
    optionsNew.style.display = "none";
  }
});
ActiveOptions.style.display = "block";

// Function to add click event listener to selectionOuter
function addClickEventListenerHSeries(selectionOuter) {
  selectionOuter.addEventListener("click", function () {
      var selection = selectionOuter.querySelector(".activeOption");
      var nearestAncestor = selection.closest(".h-series.product-compare-block");    
    var matchedDiv = document.querySelector(".matched");
      var previousDiv = document.querySelector(".previousdiv");
      if (previousDiv) {
          previousDiv.classList.remove("previousdiv");
      }

      if (nearestAncestor) {
          nearestAncestor.classList.add("previousdiv");
      }
  });
}

// Function to add change event listener to selectElement
function addChangeEventListenerHSeries(selectElement) {
  selectElement.addEventListener("change", function () {
      var selectedOptionTSeries = selectElement.options[selectElement.selectedIndex];
      for (var i = 0; i < selectElement.options.length; i++) {
          selectElement.options[i].classList.remove("selected");
      }
      selectedOptionTSeries.classList.add("selected");

      setTimeout(function () {
          var parentDiv = document.querySelector("#h-series .selected");
          var parentDivContent = parentDiv.textContent;
          var completeBlock = document.querySelectorAll(".product-compare-block");
          var matchedElement;
          completeBlock.forEach(function (element) {
              var completeBlockAttribute = element.getAttribute('value');
              if (parentDivContent === completeBlockAttribute) {
                  matchedElement = element;
                  element.classList.add('matched');
              } else {
                  element.classList.remove('matched');
              }
          });

          setTimeout(function () {
            var matchedDiv = document.querySelector(".matched");
            if (matchedDiv) {
                var previousDiv = document.querySelector(".previousdiv");
                if (previousDiv && matchedDiv) {
                    var parent = previousDiv.parentNode;

                        var indexPreviousDiv = Array.from(parent.children).indexOf(previousDiv);
                      var indexMatchedDiv = Array.from(parent.children).indexOf(matchedDiv);
              
                      if (indexPreviousDiv !== -1 && indexMatchedDiv !== -1) {
                          // Remove swiper-slide-active from all elements in the parent
                          Array.from(parent.children).forEach(function (child) {
                              child.classList.remove("swiper-slide-active");
                          });
              
                          // Swap the positions only if they are different
                          if (indexPreviousDiv !== indexMatchedDiv) {
                              parent.replaceChild(matchedDiv, previousDiv);
                              parent.insertBefore(previousDiv, parent.children[indexMatchedDiv]);
                          }
                      }
                         
                    // Reattach event listener to the moved element
                    var newSelectionOuter = document.querySelector(".product-compare-block.matched .compare-options-HSeries");
                    addClickEventListenerHSeries(newSelectionOuter);
                    var previousSelectedElement = document.querySelector(".product-compare-block.matched .compare-options-HSeries .selected");
                    if (previousSelectedElement) {
                        previousSelectedElement.classList.remove("selected");
                    }       
                    // Add swiper-slide-active to the first t-series element in the parent after div swapping
                    Array.from(parent.children).forEach(function (child) {
                        child.classList.remove("swiper-slide-active");
                    });
            
                    var firstTseriesElement = parent.querySelector(".h-series");
                    if (firstTseriesElement) {
                        firstTseriesElement.classList.add("swiper-slide-active");
                    }
                }

                 var previousDivValueH = document.querySelector(".previousdiv").getAttribute("value");
                  var selectedOptionH = document.querySelector(".previousdiv .compare-options-HSeries option.selected");
                  var options = document.querySelectorAll(".previousdiv .compare-options-HSeries option");
                    options.forEach(option => {
                      if (option.textContent.trim() === previousDivValueH.trim()) {                       
                        selectedOptionH.classList.remove("selected"); 
                        option.removeAttribute("selected");
                        option.setAttribute("selected", "selected");
                          option.click();
                      }
                    });
              
            }
          }, 500); 
        }, 300);
  });
}
var selectionOuters = document.querySelectorAll(".compare-options-HSeries");
selectionOuters.forEach(addClickEventListenerHSeries);

var selectElementsT = document.querySelectorAll(".compare-options-HSeries");
selectElementsT.forEach(addChangeEventListenerHSeries); 


  function setSelectedOption() {
    setTimeout(function() {
      var productCompareBlocks = document.querySelectorAll('.product-compare-block');
      productCompareBlocks.forEach(function(block) {
        var blockValue = block.getAttribute('value');
        var selectElementopt = block.querySelector('.compare-options-HSeries');
        if(selectElementopt){
        var options = selectElementopt.querySelectorAll('option');
        options.forEach(function(option) {
          if (option.value === blockValue) {
            option.selected = true;
          }
        });
      }
      });
    }, 800);
  }



/****************FETCHING ROBOT VACCUM ********************/
var compare = document.querySelectorAll(".compare-options-vaccum option");
var uniqueValues = new Set();
for (var i = 0; i < compare.length - 1; i++) {
    var textContent = compare[i].textContent;
    if (!uniqueValues.has(textContent)) {
        compare[i].setAttribute('value', textContent);
        uniqueValues.add(textContent);
    }
}
var blocks = document.querySelectorAll(".products-compare-wrapper .product-compare-list .compare-options-vaccum");
blocks.forEach(function(block , blockIndex) {
    uniqueValues.forEach(function(value) {
        var option = document.createElement('option');
        option.value = value;
        option.text = value;
        option.classList.add('newlyadded');
        block.add(option);
    });
    if (blockIndex < uniqueValues.size) {
        block.selectedIndex = blockIndex;
     var selectedOption = block.options[blockIndex];
      selectedOption.classList.add('activeOption');
    } else {
        block.options[blockIndex].classList.remove('activeOption');
    }
});

var ActiveOptions = document.querySelector(".activeOption");
var newAddedOptions = document.querySelectorAll(".newlyadded");
newAddedOptions.forEach(function(optionsNew) {
  var data = optionsNew.textContent;
  if (optionsNew.classList.contains("activeOption")) {
    optionsNew.style.display = "block";
  } else {
    optionsNew.style.display = "none";
  }
});
ActiveOptions.style.display = "block";


// Function to add click event listener to selectionOuter
function addClickEventListenerVaccum(selectionOuter) {
  selectionOuter.addEventListener("click", function () {
      var selection = selectionOuter.querySelector(".activeOption");
      var nearestAncestor = selection.closest(".robot-vacuum.product-compare-block");    
    var matchedDiv = document.querySelector(".matched");
      var previousDiv = document.querySelector(".previousdiv");
      if (previousDiv) {
          previousDiv.classList.remove("previousdiv");
      }

      if (nearestAncestor) {
          nearestAncestor.classList.add("previousdiv");
      }
  });
}

// Function to add change event listener to selectElement
function addChangeEventListenerVaccum(selectElement) {
  selectElement.addEventListener("change", function () {
      var selectedOptionTSeries = selectElement.options[selectElement.selectedIndex];
      for (var i = 0; i < selectElement.options.length; i++) {
          selectElement.options[i].classList.remove("selected");
      }
      selectedOptionTSeries.classList.add("selected");

      setTimeout(function () {
          var parentDiv = document.querySelector("#robot-vacuum .selected");
          var parentDivContent = parentDiv.textContent;
          var completeBlock = document.querySelectorAll(".product-compare-block");
          var matchedElement;
          completeBlock.forEach(function (element) {
              var completeBlockAttribute = element.getAttribute('value');
              if (parentDivContent === completeBlockAttribute) {
                  matchedElement = element;
                  element.classList.add('matched');
              } else {
                  element.classList.remove('matched');
              }
          });

          setTimeout(function () {
            var matchedDiv = document.querySelector(".matched");
            if (matchedDiv) {
                var previousDiv = document.querySelector(".previousdiv");
                if (previousDiv && matchedDiv) {
                    var parent = previousDiv.parentNode;
                    var indexPreviousDiv = Array.from(parent.children).indexOf(previousDiv);
                    var indexMatchedDiv = Array.from(parent.children).indexOf(matchedDiv);
            
                    if (indexPreviousDiv !== -1 && indexMatchedDiv !== -1) {
                        // Remove swiper-slide-active from all elements in the parent
                        Array.from(parent.children).forEach(function (child) {
                            child.classList.remove("swiper-slide-active");
                        });
            
                        // Swap the positions only if they are different
                        if (indexPreviousDiv !== indexMatchedDiv) {
                            parent.replaceChild(matchedDiv, previousDiv);
                            parent.insertBefore(previousDiv, parent.children[indexMatchedDiv]);
                        }
                    }
                
                    // Reattach event listener to the moved element
                    var newSelectionOuter = document.querySelector(".product-compare-block.matched .compare-options-vaccum");
                    addClickEventListenerVaccum(newSelectionOuter);
                    var previousSelectedElement = document.querySelector(".product-compare-block.matched .compare-options-vaccum .selected");
                    if (previousSelectedElement) {
                        previousSelectedElement.classList.remove("selected");
                    }       
                    // Add swiper-slide-active to the first t-series element in the parent after div swapping
                    Array.from(parent.children).forEach(function (child) {
                        child.classList.remove("swiper-slide-active");
                    });
            
                    var firstTseriesElement = parent.querySelector(".robot-vacuum");
                    if (firstTseriesElement) {
                        firstTseriesElement.classList.add("swiper-slide-active");
                    }
                }
                 var previousDivValueVaccum = document.querySelector(".previousdiv").getAttribute("value");
                  var selectedOptionvaccum = document.querySelector(".previousdiv .compare-options-vaccum option.selected");
                  var options = document.querySelectorAll(".previousdiv .compare-options-vaccum option");
                    options.forEach(option => {
                      if (option.textContent.trim() === previousDivValueVaccum.trim()) {                       
                        selectedOptionvaccum.classList.remove("selected"); 
                        option.removeAttribute("selected");
                        option.setAttribute("selected", "selected");
                          option.click();
                      }
                    });
            }
          }, 500); 
        }, 300);
  });
}


var selectionOuters = document.querySelectorAll(".compare-options-vaccum");
selectionOuters.forEach(addClickEventListenerVaccum);

var selectElementsT = document.querySelectorAll(".compare-options-vaccum");
selectElementsT.forEach(addChangeEventListenerVaccum);

  function setSelectedOptionvaccum() {
    setTimeout(function() {
      var productCompareBlocks = document.querySelectorAll('.product-compare-block');
      productCompareBlocks.forEach(function(block) {
        var blockValue = block.getAttribute('value');
        var selectElementopt = block.querySelector('.compare-options-vaccum');
        if(selectElementopt){
        setTimeout(function() {
        var options = selectElementopt.querySelectorAll('option');
        options.forEach(function(option) {
          if (option.value === blockValue) {
            option.selected = true;
          }
        });
          }, 1000);
      }
      });
    }, 800);
  }






/****************FETCHING STICK VACCUM ********************/
var compareStickV = document.querySelectorAll(".compare-options-stick-vaccum option");
var uniqueValuesStickV = new Set();
for (var i = 0; i < compareStickV.length - 1; i++) {
    var textContentStickV = compareStickV[i].textContent;
    if (!uniqueValuesStickV.has(textContentStickV)) {
        compareStickV[i].setAttribute('value', textContentStickV);
        uniqueValuesStickV.add(textContentStickV);
    }
}
var blocksStickV = document.querySelectorAll(".products-compare-wrapper .product-compare-list .compare-options-stick-vaccum");
blocksStickV.forEach(function(blockStickV , blockIndexStickV) {
    uniqueValuesStickV.forEach(function(valueStickV) {
        var optionStickV = document.createElement('option');
        optionStickV.value = valueStickV;
        optionStickV.text = valueStickV;
        optionStickV.classList.add('newlyadded');
        blockStickV.add(optionStickV);
    });
    if (blockIndexStickV < uniqueValuesStickV.size) {
        blockStickV.selectedIndex = blockIndexStickV;
        var selectedOptionStickV = blockStickV.options[blockIndexStickV];
        selectedOptionStickV.classList.add('activeOption');
    } else {
        blockStickV.options[blockIndexStickV].classList.remove('activeOption');
    }
});

var activeOptionsStickV = document.querySelector(".activeOption");
var newAddedOptionsStickV = document.querySelectorAll(".newlyadded");
newAddedOptionsStickV.forEach(function(optionsNewStickV) {
  var dataStickV = optionsNewStickV.textContent;
  if (optionsNewStickV.classList.contains("activeOption")) {
    optionsNewStickV.style.display = "block";
  } else {
    optionsNewStickV.style.display = "none";
  }
});
activeOptionsStickV.style.display = "block";


// Function to add click event listener to selectionOuter
function addClickEventListenerStickV(selectionOuterStickV) {
  selectionOuterStickV.addEventListener("click", function () {
      var selectionStickV = selectionOuterStickV.querySelector(".activeOption");
      var nearestAncestorStickV = selectionStickV.closest(".stick-vacuums.product-compare-block");    
      var matchedDivStickV = document.querySelector(".matched");
      var previousDivStickV = document.querySelector(".previousdiv");
      if (previousDivStickV) {
          previousDivStickV.classList.remove("previousdiv");
      }

      if (nearestAncestorStickV) {
          nearestAncestorStickV.classList.add("previousdiv");
      }
  });
}

// Function to add change event listener to selectElement
function addChangeEventListenerStickV(selectElementStickV) {
  selectElementStickV.addEventListener("change", function () {
      var selectedOptionTSeriesStickV = selectElementStickV.options[selectElementStickV.selectedIndex];
      for (var i = 0; i < selectElementStickV.options.length; i++) {
          selectElementStickV.options[i].classList.remove("selected");
      }
      selectedOptionTSeriesStickV.classList.add("selected");

      setTimeout(function () {
          var parentDivStickV = document.querySelector("#stick-vacuums .selected");
          var parentDivContentStickV = parentDivStickV.textContent;
          var completeBlockStickV = document.querySelectorAll(".product-compare-block");
          var matchedElementStickV;
          completeBlockStickV.forEach(function (elementStickV) {
              var completeBlockAttributeStickV = elementStickV.getAttribute('value');
              if (parentDivContentStickV === completeBlockAttributeStickV) {
                  matchedElementStickV = elementStickV;
                  elementStickV.classList.add('matched');
              } else {
                  elementStickV.classList.remove('matched');
              }
          });

          setTimeout(function () {
            var matchedDivStickV = document.querySelector(".matched");
            if (matchedDivStickV) {
                var previousDivStickV = document.querySelector(".previousdiv");
                if (previousDivStickV && matchedDivStickV) {
                    var parentStickV = previousDivStickV.parentNode;
                    var indexPreviousDivStickV = Array.from(parentStickV.children).indexOf(previousDivStickV);
                    var indexMatchedDivStickV = Array.from(parentStickV.children).indexOf(matchedDivStickV);
            
                    if (indexPreviousDivStickV !== -1 && indexMatchedDivStickV !== -1) {
                        // Remove swiper-slide-active from all elements in the parent
                        Array.from(parentStickV.children).forEach(function (childStickV) {
                            childStickV.classList.remove("swiper-slide-active");
                        });
            
                        // Swap the positions only if they are different
                        if (indexPreviousDivStickV !== indexMatchedDivStickV) {
                            parentStickV.replaceChild(matchedDivStickV, previousDivStickV);
                            parentStickV.insertBefore(previousDivStickV, parentStickV.children[indexMatchedDivStickV]);
                        }
                    }
                
                    // Reattach event listener to the moved element
                    var newSelectionOuterStickV = document.querySelector(".product-compare-block.matched .compare-options-stick-vaccum");
                    addClickEventListenerStickV(newSelectionOuterStickV);
                    var previousSelectedElementStickV = document.querySelector(".product-compare-block.matched .compare-options-stick-vaccum .selected");
                    if (previousSelectedElementStickV) {
                        previousSelectedElementStickV.classList.remove("selected");
                    }       
                    // Add swiper-slide-active to the first t-series element in the parent after div swapping
                    Array.from(parentStickV.children).forEach(function (childStickV) {
                        childStickV.classList.remove("swiper-slide-active");
                    });
            
                    var firstTseriesElementStickV = parentStickV.querySelector(".stick-vacuums");
                    if (firstTseriesElementStickV) {
                        firstTseriesElementStickV.classList.add("swiper-slide-active");
                    }
                }
                 var previousDivValueStickV = document.querySelector(".previousdiv").getAttribute("value");
                 var selectedOptionStickV = document.querySelector(".previousdiv .compare-options-stick-vaccum option.selected");
                 var optionsStickV = document.querySelectorAll(".previousdiv .compare-options-stick-vaccum option");
                 optionsStickV.forEach(optionStickV => {
                      if (optionStickV.textContent.trim() === previousDivValueStickV.trim()) {                       
                        selectedOptionStickV.classList.remove("selected"); 
                        optionStickV.removeAttribute("selected");
                        optionStickV.setAttribute("selected", "selected");
                        optionStickV.click();
                      }
                 });
            }
          }, 500); 
        }, 300);
  });
}


var selectionOutersStickV = document.querySelectorAll(".compare-options-stick-vaccum");
selectionOutersStickV.forEach(addClickEventListenerStickV);

var selectElementsStickV = document.querySelectorAll(".compare-options-stick-vaccum");
selectElementsStickV.forEach(addChangeEventListenerStickV);

function setSelectedOptionStickV() {
    setTimeout(function() {
      var productCompareBlocksStickV = document.querySelectorAll('.product-compare-block');
      productCompareBlocksStickV.forEach(function(blockStickV) {
        var blockValueStickV = blockStickV.getAttribute('value');
        var selectElementoptStickV = blockStickV.querySelector('.compare-options-stick-vaccum');
        if(selectElementoptStickV){
          setTimeout(function() {
            var optionsStickV = selectElementoptStickV.querySelectorAll('option');
            optionsStickV.forEach(function(optionStickV) {
              if (optionStickV.value === blockValueStickV) {
                optionStickV.selected = true;
              }
            });
          }, 1000);
        }
      });
    }, 800);
}


// Beauty Care Compare Code
var compareBeautyCare = document.querySelectorAll(".compare-options-beauty-care option");
var uniqueValuesBeautyCare = new Set();
for (var i = 0; i < compareBeautyCare.length - 1; i++) {
    var textContentBeautyCare = compareBeautyCare[i].textContent;
    if (!uniqueValuesBeautyCare.has(textContentBeautyCare)) {
        compareBeautyCare[i].setAttribute('value', textContentBeautyCare);
        uniqueValuesBeautyCare.add(textContentBeautyCare);
    }
}
var blocksBeautyCare = document.querySelectorAll(".products-compare-wrapper .product-compare-list .compare-options-beauty-care");
blocksBeautyCare.forEach(function(blockBeautyCare , blockIndexBeautyCare) {
    uniqueValuesBeautyCare.forEach(function(valueBeautyCare) {
        var optionBeautyCare = document.createElement('option');
        optionBeautyCare.value = valueBeautyCare;
        optionBeautyCare.text = valueBeautyCare;
        optionBeautyCare.classList.add('newlyadded');
        blockBeautyCare.add(optionBeautyCare);
    });
    if (blockIndexBeautyCare < uniqueValuesBeautyCare.size) {
        blockBeautyCare.selectedIndex = blockIndexBeautyCare;
        var selectedOptionBeautyCare = blockBeautyCare.options[blockIndexBeautyCare];
        selectedOptionBeautyCare.classList.add('activeOption');
    } else {
        blockBeautyCare.options[blockIndexBeautyCare].classList.remove('activeOption');
    }
});

var activeOptionsBeautyCare = document.querySelector(".activeOption");
var newAddedOptionsBeautyCare = document.querySelectorAll(".newlyadded");
newAddedOptionsBeautyCare.forEach(function(optionsNewBeautyCare) {
  var dataBeautyCare = optionsNewBeautyCare.textContent;
  if (optionsNewBeautyCare.classList.contains("activeOption")) {
    optionsNewBeautyCare.style.display = "block";
  } else {
    optionsNewBeautyCare.style.display = "none";
  }
});
activeOptionsBeautyCare.style.display = "block";


// Function to add click event listener to selectionOuter
function addClickEventListenerBeautyCare(selectionOuterBeautyCare) {
  selectionOuterBeautyCare.addEventListener("click", function () {
      var selectionBeautyCare = selectionOuterBeautyCare.querySelector(".activeOption");
      var nearestAncestorBeautyCare = selectionBeautyCare.closest(".beauty-care.product-compare-block");    
      var matchedDivBeautyCare = document.querySelector(".matched");
      var previousDivBeautyCare = document.querySelector(".previousdiv");
      if (previousDivBeautyCare) {
          previousDivBeautyCare.classList.remove("previousdiv");
      }

      if (nearestAncestorBeautyCare) {
          nearestAncestorBeautyCare.classList.add("previousdiv");
      }
  });
}

// Function to add change event listener to selectElement
function addChangeEventListenerBeautyCare(selectElementBeautyCare) {
  selectElementBeautyCare.addEventListener("change", function () {
      var selectedOptionTSeriesBeautyCare = selectElementBeautyCare.options[selectElementBeautyCare.selectedIndex];
      for (var i = 0; i < selectElementBeautyCare.options.length; i++) {
          selectElementBeautyCare.options[i].classList.remove("selected");
      }
      selectedOptionTSeriesBeautyCare.classList.add("selected");

      setTimeout(function () {
          var parentDivBeautyCare = document.querySelector("#beauty-care .selected");
          var parentDivContentBeautyCare = parentDivBeautyCare.textContent;
          var completeBlockBeautyCare = document.querySelectorAll(".product-compare-block");
          var matchedElementBeautyCare;
          completeBlockBeautyCare.forEach(function (elementBeautyCare) {
              var completeBlockAttributeBeautyCare = elementBeautyCare.getAttribute('value');
              if (parentDivContentBeautyCare === completeBlockAttributeBeautyCare) {
                  matchedElementBeautyCare = elementBeautyCare;
                  elementBeautyCare.classList.add('matched');
              } else {
                  elementBeautyCare.classList.remove('matched');
              }
          });

          setTimeout(function () {
            var matchedDivBeautyCare = document.querySelector(".matched");
            if (matchedDivBeautyCare) {
                var previousDivBeautyCare = document.querySelector(".previousdiv");
                if (previousDivBeautyCare && matchedDivBeautyCare) {
                    var parentBeautyCare = previousDivBeautyCare.parentNode;
                    var indexPreviousDivBeautyCare = Array.from(parentBeautyCare.children).indexOf(previousDivBeautyCare);
                    var indexMatchedDivBeautyCare = Array.from(parentBeautyCare.children).indexOf(matchedDivBeautyCare);
            
                    if (indexPreviousDivBeautyCare !== -1 && indexMatchedDivBeautyCare !== -1) {
                        // Remove swiper-slide-active from all elements in the parent
                        Array.from(parentBeautyCare.children).forEach(function (childBeautyCare) {
                            childBeautyCare.classList.remove("swiper-slide-active");
                        });
            
                        // Swap the positions only if they are different
                        if (indexPreviousDivBeautyCare !== indexMatchedDivBeautyCare) {
                            parentBeautyCare.replaceChild(matchedDivBeautyCare, previousDivBeautyCare);
                            parentBeautyCare.insertBefore(previousDivBeautyCare, parentBeautyCare.children[indexMatchedDivBeautyCare]);
                        }
                    }
                
                    // Reattach event listener to the moved element
                    var newSelectionOuterBeautyCare = document.querySelector(".product-compare-block.matched .compare-options-beauty-care");
                    addClickEventListenerBeautyCare(newSelectionOuterBeautyCare);
                    var previousSelectedElementBeautyCare = document.querySelector(".product-compare-block.matched .compare-options-beauty-care .selected");
                    if (previousSelectedElementBeautyCare) {
                        previousSelectedElementBeautyCare.classList.remove("selected");
                    }       
                    // Add swiper-slide-active to the first t-series element in the parent after div swapping
                    Array.from(parentBeautyCare.children).forEach(function (childBeautyCare) {
                        childBeautyCare.classList.remove("swiper-slide-active");
                    });
            
                    var firstTseriesElementBeautyCare = parentBeautyCare.querySelector(".beauty-care");
                    if (firstTseriesElementBeautyCare) {
                        firstTseriesElementBeautyCare.classList.add("swiper-slide-active");
                    }
                }
                 var previousDivValueBeautyCare = document.querySelector(".previousdiv").getAttribute("value");
                 var selectedOptionBeautyCare = document.querySelector(".previousdiv .compare-options-beauty-care option.selected");
                 var optionsBeautyCare = document.querySelectorAll(".previousdiv .compare-options-beauty-care option");
                 optionsBeautyCare.forEach(optionBeautyCare => {
                      if (optionBeautyCare.textContent.trim() === previousDivValueBeautyCare.trim()) {                       
                        selectedOptionBeautyCare.classList.remove("selected"); 
                        optionBeautyCare.removeAttribute("selected");
                        optionBeautyCare.setAttribute("selected", "selected");
                        optionBeautyCare.click();
                      }
                 });
            }
          }, 500); 
        }, 300);
  });
}


var selectionOutersBeautyCare = document.querySelectorAll(".compare-options-beauty-care");
selectionOutersBeautyCare.forEach(addClickEventListenerBeautyCare);

var selectElementsBeautyCare = document.querySelectorAll(".compare-options-beauty-care");
selectElementsBeautyCare.forEach(addChangeEventListenerBeautyCare);

function setSelectedOptionBeautyCare() {
    setTimeout(function() {
      var productCompareBlocksBeautyCare = document.querySelectorAll('.product-compare-block');
      productCompareBlocksBeautyCare.forEach(function(blockBeautyCare) {
        var blockValueBeautyCare = blockBeautyCare.getAttribute('value');
        var selectElementoptBeautyCare = blockBeautyCare.querySelector('.compare-options-beauty-care');
        if(selectElementoptBeautyCare){
          setTimeout(function() {
            var optionsBeautyCare = selectElementoptBeautyCare.querySelectorAll('option');
            optionsBeautyCare.forEach(function(optionBeautyCare) {
              if (optionBeautyCare.value === blockValueBeautyCare) {
                optionBeautyCare.selected = true;
              }
            });
          }, 1000);
        }
      });
    }, 800);
}